import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box, IconButton, Stack, type SxProps, type Theme, Typography } from "@mui/material";

interface CounterProps {
  label?: React.ReactNode;
  description?: string;
  count: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

export default function Counter({
  label,
  description,
  count,
  onChange,
  min = 0,
  max = 99,
  disabled = false,
  sx,
}: CounterProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 2,
        ...sx,
      }}
    >
      {(label || description) && (
        <Stack>
          {label && <Typography fontWeight={600}>{label}</Typography>}
          {description && (
            <Typography variant="body1" color="text.secondary">
              {new DOMParser().parseFromString(description, "text/html").body.textContent}
            </Typography>
          )}
        </Stack>
      )}
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <IconButton
          size="small"
          onClick={() => onChange(Math.max(min, count - 1))}
          disabled={disabled || count <= min}
          sx={{
            bgcolor: "grey.100",
            "&.Mui-disabled": { bgcolor: "grey.100" },
            "&:hover": { bgcolor: "grey.100" },
          }}
        >
          <RemoveIcon />
        </IconButton>
        <Typography sx={{ minWidth: 30, textAlign: "center", fontWeight: 600 }}>{count}</Typography>
        <IconButton
          size="small"
          onClick={() => onChange(Math.min(max, count + 1))}
          disabled={disabled || count >= max}
          sx={{
            bgcolor: "grey.100",
            "&.Mui-disabled": { bgcolor: "grey.100" },
            "&:hover": { bgcolor: "grey.100" },
          }}
        >
          <AddIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
